import { sum } from 'lodash';

/**
 * Distributes a drag delta across the selected column widths while respecting a minimum width.
 */
export const getNewColumnWidthsPx = (
    selectedCols: number[],
    initialColWidths: number[],
    minColWidth: number,
    dif: number,
): number[] => {
    const resizingColCount = selectedCols.length;
    const difPerCol = dif / resizingColCount;
    const newColWidths = initialColWidths.map((initial: number) => Math.max(initial + difPerCol, minColWidth));

    if (dif > 0) return newColWidths;

    let overflow = sum(newColWidths) - sum(initialColWidths) - dif;
    if (overflow === 0) return newColWidths;

    while (overflow > 0.5) {
        const colsAboveMin = newColWidths.filter((width) => width > minColWidth).length;
        if (colsAboveMin === 0) return newColWidths;

        const removePerCol = overflow / colsAboveMin;

        for (let i = 0; i < resizingColCount; i++) {
            if (newColWidths[i] === minColWidth) continue;

            const nextWidth = newColWidths[i] - removePerCol;

            if (nextWidth < minColWidth) {
                overflow += minColWidth - nextWidth;
                newColWidths[i] = minColWidth;
                continue;
            }

            overflow -= removePerCol;
            newColWidths[i] = nextWidth;
        }
    }

    return newColWidths;
};
